import React, { memo } from 'react';
import LaunchIcon from '@material-ui/icons/Launch';

import logo from './logo.svg';

import {
  Wrapper,
  Container,
  Title,
  Content,
  CantLoad,
  Status,
  Button,
} from './ErrorPage.styled';

interface ErrorResponse {
  status?: number;
}

interface ErrorPageProps {
  error?: {
    response?: ErrorResponse;
  } | null;
}

const ErrorPage = ({ error }: ErrorPageProps) => {
  const forceRefresh = () => {
    window.location.reload();
  };

  const status = error?.response?.status;

  const content =
    status === 451 ? (
      <>
        <div>This service is only accessible within the United Kingdom.</div>
        <div>
          It looks like you&apos;re trying to access it from a location outside
          the permitted region.
        </div>
      </>
    ) : (
      <>
        <div>Couldn&apos;t load Aula. Please try again in a few minutes.</div>
      </>
    );

  return (
    <Wrapper data-testid="error-page">
      <Container>
        <img src={logo} alt="Aula" />
        <Title>Something went wrong</Title>
        <Content>
          <CantLoad>
            {content}
            <br />
            You can also check{' '}
            <Status
              href="https://aulaeducation.statuspage.io/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Aula’s status here <LaunchIcon />
            </Status>
          </CantLoad>
          <Button onClick={forceRefresh}>Retry to load</Button>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default memo(ErrorPage);
